<div class="row" *ngIf="currentOrganization$ | async as currentOrganization">
  <router-outlet></router-outlet>
</div>
